module.exports = __webpack_public_path__ + "img/IT0000564659589.9b8381b1.svg";